import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { isRetailer } from "@faire/help-center-utils/serialized-data/getRetailer";
import { getRetailerOrBrandToken } from "@faire/help-center-utils/serialized-data/getRetailerOrBrandToken";
import { QueryParameters as IBrandOrdersRequest } from "@faire/web-api/api/help-center/brand-orders/get";
import { useQuery as useBrandOrdersRequest } from "@faire/web-api/api/help-center/brand-orders/get-hooks";
import { BrandOrderFulfillmentState } from "@faire/web-api/indigofair/data/BrandOrderFulfillmentState";
import { BrandOrderSource } from "@faire/web-api/indigofair/data/BrandOrderSource";
import { IBrandOrder } from "@faire/web-api/indigofair/data/IBrandOrder";
import { IListOrdersByBrandOrderResponse } from "@faire/web-api/indigofair/data/IListOrdersByBrandOrderResponse";
import { intlDate } from "@faire/web/common/localization/date-fns/intlDate";
import isFuture from "date-fns/isFuture";
import isPast from "date-fns/isPast";
import uniqBy from "lodash/uniqBy";
import { useMemo } from "react";
import { QuickActionType } from "../types";
import { useActionTypes } from "./useActionTypes";
var BRAND_ORDERS_MAX_QUANTITY = 50;
export var useBrandOrders = function useBrandOrders() {
  var brandOrderPayload = isRetailer() ? IBrandOrdersRequest.build({
    retailerToken: getRetailerOrBrandToken(),
    pageSize: 100
  }) : IBrandOrdersRequest.build({
    brandToken: getRetailerOrBrandToken(),
    pageSize: 100
  });
  var _useBrandOrdersReques = useBrandOrdersRequest(brandOrderPayload),
    brandOrderResponse = _useBrandOrdersReques.data,
    isBrandOrderRequestLoading = _useBrandOrdersReques.isLoading;
  var _useActionTypes = useActionTypes(),
    actionType = _useActionTypes.actionType;
  var nameLookupTable = useMemo(function () {
    var _brandOrderResponse$b2;
    if (!brandOrderResponse) {
      return {};
    }
    if (isRetailer()) {
      var _brandOrderResponse$b;
      return (_brandOrderResponse$b = brandOrderResponse.brand_order_tokens_to_brand_names) !== null && _brandOrderResponse$b !== void 0 ? _brandOrderResponse$b : {};
    }
    return (_brandOrderResponse$b2 = brandOrderResponse.brand_order_tokens_to_retailer_names) !== null && _brandOrderResponse$b2 !== void 0 ? _brandOrderResponse$b2 : {};
  }, [brandOrderResponse]);
  var brandOwnerTokenTable = useMemo(function () {
    if (!brandOrderResponse) {
      return {};
    }
    return brandOrderResponse === null || brandOrderResponse === void 0 ? void 0 : brandOrderResponse.brand_order_tokens_to_brand_owner_tokens;
  }, [brandOrderResponse]);
  var timestampLookupTable = useMemo(function () {
    if (!brandOrderResponse) {
      return {};
    }
    return brandOrderResponse === null || brandOrderResponse === void 0 ? void 0 : brandOrderResponse.brand_order_tokens_to_created_at_timestamps;
  }, [brandOrderResponse]);
  var isUpdateCommissionModal = (actionType === null || actionType === void 0 ? void 0 : actionType.id) === QuickActionType.REQUEST_COMMISSION_CHANGE;
  var brandOrders = useMemo(function () {
    if (isBrandOrderRequestLoading || actionType === undefined) {
      return [];
    }
    var brandOrders = brandOrderResponse === null || brandOrderResponse === void 0 ? void 0 : brandOrderResponse.brand_orders;
    switch (actionType.id) {
      case QuickActionType.ACCEPT_AN_ORDER:
        return brandOrders === null || brandOrders === void 0 ? void 0 : brandOrders.filter(function (brandOrder) {
          return brandOrder.fulfillment_state === BrandOrderFulfillmentState.NEW;
        }).slice(0, BRAND_ORDERS_MAX_QUANTITY);
      case QuickActionType.REQUEST_COMMISSION_CHANGE:
        return uniqBy(brandOrders === null || brandOrders === void 0 ? void 0 : brandOrders.filter(function (brandOrder) {
          return brandOrder.source === BrandOrderSource.MARKETPLACE;
        }), function (brandOrder) {
          return nameLookupTable[brandOrder.token];
        }).slice(0, BRAND_ORDERS_MAX_QUANTITY);
      case QuickActionType.CANCEL_AN_ORDER:
      case QuickActionType.EDIT_ITEM_AVAILABILITY:
        return brandOrders === null || brandOrders === void 0 ? void 0 : brandOrders.filter(function (brandOrder) {
          return brandOrder.state === IBrandOrder.State.NEW || brandOrder.state === IBrandOrder.State.BRAND_CONTACTED || brandOrder.state === IBrandOrder.State.PROCESSING || brandOrder.state === IBrandOrder.State.WAITING_ON_REVIEW || brandOrder.fulfillment_state === BrandOrderFulfillmentState.UNFULFILLED;
        }).slice(0, BRAND_ORDERS_MAX_QUANTITY);
      case QuickActionType.RETURN_ITEMS:
        return brandOrders === null || brandOrders === void 0 ? void 0 : brandOrders.filter(function (brandOrder) {
          return brandOrder.state === IBrandOrder.State.DELIVERED && brandOrder.returnable_until != null && isFuture(brandOrder.returnable_until);
        }).slice(0, BRAND_ORDERS_MAX_QUANTITY);
      case QuickActionType.REPORT_DAMAGED_OR_MISSING_ITEMS:
        return brandOrders === null || brandOrders === void 0 ? void 0 : brandOrders.filter(function (brandOrder) {
          return brandOrder.state === IBrandOrder.State.DELIVERED && brandOrder.report_issue_eligibility !== IListOrdersByBrandOrderResponse.IBrandOrderData.IEligibility.Enum.NOT_ELIGIBLE;
        }).slice(0, BRAND_ORDERS_MAX_QUANTITY);
      default:
        return brandOrders;
    }
  }, [brandOrderResponse === null || brandOrderResponse === void 0 ? void 0 : brandOrderResponse.brand_orders, isBrandOrderRequestLoading, nameLookupTable, actionType]);
  var dropdownOptions = useMemo(function () {
    if (!brandOrders) {
      return [];
    }
    if (isUpdateCommissionModal) {
      return brandOrders.filter(function (brandOrder) {
        return !!brandOrder.token;
      }).map(function (brandOrder) {
        var token = brandOrder.token;
        return {
          name: nameLookupTable[token],
          value: token
        };
      });
    }
    return brandOrders.filter(function (brandOrder) {
      return !!brandOrder.token;
    }).map(function (brandOrder) {
      var _brandOrder$token, _brandOrder$token$rep;
      var token = brandOrder.token;
      var timestampEntry = timestampLookupTable[token];
      var timestamp = isRetailer() && timestampEntry ? timestampEntry : brandOrder.brand_contacted_at;
      var date = intlDate(new Date(timestamp), "MMM d");
      var name = nameLookupTable[token];
      var brandOwnerToken = brandOwnerTokenTable[token];
      var customerBrandOrderToken = (_brandOrder$token = brandOrder.token) === null || _brandOrder$token === void 0 ? void 0 : (_brandOrder$token$rep = _brandOrder$token.replace("bo_", "#")) === null || _brandOrder$token$rep === void 0 ? void 0 : _brandOrder$token$rep.toUpperCase();
      var notShipped = brandOrder.state !== IBrandOrder.State.SHIPPED && brandOrder.state !== IBrandOrder.State.DELIVERED;
      var beingFulfilled = brandOrder.fulfillment_state === BrandOrderFulfillmentState.UNFULFILLED;
      var needExtension = isPast(new Date(brandOrder.issue_reportable_until));
      return {
        label: "".concat(date, " - ").concat(name, " - ").concat(customerBrandOrderToken),
        value: brandOrder.token,
        date: date,
        name: name,
        customerBrandOrderToken: customerBrandOrderToken,
        notShipped: notShipped,
        beingFulfilled: beingFulfilled,
        orderToken: brandOrder.order_token,
        brandToken: brandOrder.brand_token,
        brandOwnerToken: brandOwnerToken,
        needExtension: needExtension
      };
    });
  }, [brandOrders, brandOwnerTokenTable, isUpdateCommissionModal, nameLookupTable, timestampLookupTable]);
  return {
    brandOrders: brandOrders,
    nameLookupTable: nameLookupTable,
    timestampLookupTable: timestampLookupTable,
    brandOwnerTokenTable: brandOwnerTokenTable,
    isUpdateCommissionModal: isUpdateCommissionModal,
    dropdownOptions: dropdownOptions
  };
};